import { DateTime as LDateTime } from 'luxon';
import { DateZone } from '@oai-frontend-monorepo/types';

export const est = () => {
  const utc = LDateTime.utc();

  return utc.setZone(DateZone.New_York);
};

export const fromFormat = (date: string, format: string) => {
  const dateObj = LDateTime.fromFormat(date, format, {
    zone: DateZone.New_York,
  });

  if (!dateObj.isValid) {
    throw new Error(`Invalid date: ${date}`);
  }

  return dateObj;
};
